import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Schedules = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Schedules' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M17,7 L23,7 L23,23 L7,23 L7,19 M23,11 L17,11 M13,0 L13,3 M1,7 L17,7 M1,3 L17,3 L17,19 L1,19 L1,3 Z M5,0 L5,3 M4,11 L6,11 M8,11 L14,11 M4,15 L6,15 M8,15 L14,15' />
  </StyledIcon>
);
